import { Button, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/axcess logo_reversed-2.svg';
import background from '../../assets/trees.jpg';
import Box from '../UI';

export default function Landing({ children }) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.background} />
			<div className={classes.polygon} />
			<img className={classes.logo} src={logo} alt="aXcess Logo" />
			<Box className={classes.content}>
				<Typography className={classes.text} variant="h3">
					<strong>An innovative commercial real estate platform</strong>
				</Typography>
				<Typography className={classes.text} variant="body1">
					<strong>
					A platform designed to bring a new approach to the buying and selling of commercial real estate	
					</strong>
				</Typography>
				<Box display="flex" justifyContent="space-between">
					<Button className={classes.button} variant="contained" color="primary" component={Link} to='/auth' >
						Login
					</Button>
					<Button className={classes.button} variant="contained" component={Link} to='/auth' >
						Sign Up
					</Button>
				</Box>
			</Box>
		</div>
	);
}

const useStyles = makeStyles(theme => ({
	root: {
		zIndex: 0,
		width: '100vw',
		height: '100vh',
		position: 'relative',
		overflow: 'hidden',
	},
	polygon: {
		zIndex: 2,
		width: '100%',
		height: '100%',
		position: 'absolute',
		top: 0,
		left: 0,
		background: '#424242',
		opacity: 0.95,
		[theme.breakpoints.up('md')]: {
			clipPath: 'polygon(0 0, 27% 0, 50% 67%, 37% 100%, 0 100%)',
		},
	},
	background: {
		zIndex: 1,
		width: '100vw',
		height: '100vh',
		position: 'absolute',
		left: 0,
		top: 0,
		backgroundImage: `url(${background})`,
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
	},
	logo: {
		zIndex: 2,
		position: 'absolute',
		top: '64px',
		left: '64px',
		height: '36px',
		[theme.breakpoints.down('sm')]: {
			position: 'relative',
			top: 0,
			left: 0,
			margin: theme.spacing(4),
		},
	},
	content: {
		zIndex: 2,
		position: 'absolute',
		bottom: '128px',
		left: '64px',
		maxWidth: '400px',
		[theme.breakpoints.down('sm')]: {
			position: 'relative',
			top: 0,
			left: 0,
			width: '100%',
			padding: theme.spacing(4),
		},
	},
	text: {
		color: 'white',
		marginBottom: theme.spacing(4),
	},
	button: {
		width: '49%',
	},
}));
